import { createAction } from '@reduxjs/toolkit'

export const setGamesData = createAction<any[]>('games/setGamesData')
export const setGamesLoading = createAction<boolean>('games/setGamesLoading')
export const setRewardInfo = createAction<{
  rewardId: number | string
  rewardType: number
}>('games/setRewardInfo')
